import { render } from "./LoginFormBootstrap.vue?vue&type=template&id=1813ff42&scoped=true"
import script from "./LoginFormBootstrap.vue?vue&type=script&lang=js"
export * from "./LoginFormBootstrap.vue?vue&type=script&lang=js"

import "./LoginFormBootstrap.vue?vue&type=style&index=0&id=1813ff42&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\PeD\\WebCNCMonitor\\dashboard\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1813ff42"]])

export default __exports__